import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective
} from "@syncfusion/ej2-vue-grids";
import {Api} from "@/shared/services/api";
import {CustomAdaptor} from "@/shared/types/CustomAdaptor";
import {ref} from "vue";
import {DataManager} from "@syncfusion/ej2-data/src/manager";
import InsuranceCancelation from "@/shared/model/InsuranceCancelation";
import {SelectionSettingsModel} from "@syncfusion/ej2-grids/src/grid/base/grid-model";
import {useNavigationStore} from "@/modules/Navigation/store";

interface Props {
  selected?: (array: InsuranceCancelation[]) => void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ManagementListDetailsComponent',
  props: {
    selected: { type: Function, default: undefined }
  },
  emits: ["selected"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props
const _url = Api.baseUrl + '/InsuranceCancelationList';
const _adaptor = new CustomAdaptor()
const _grid = ref<InstanceType<typeof GridComponent> | null>(null)
const _navigationStore = useNavigationStore()
const _pageSettings = {pageSize: 50, pageSizes: ["All", 10, 25, 50, 100]}
const selectionOptions: SelectionSettingsModel = {type: 'Multiple', enableSimpleMultiRowSelection: true}


const _dataManager = new DataManager({
  url: _url,
  adaptor: _adaptor,
  crossDomain: true,
})

const _emit = __emit

function onRowSelected(args: any) {
  _navigationStore.currentInsuranceCancelationId = args.data.id;
  _emit("selected", args.data as InsuranceCancelation)
  onSelected()
}

function onRowDeselected(args: any) {
  if (!args.isInteracted)
    return
  _emit("selected", undefined)
  onSelected()
}

function onSelected() {
  if (props.selected) {
    const list = _grid.value?.getSelectedRecords()?.map(t => t as InsuranceCancelation);
    props.selected(list ?? [])
  }
}

function refresh() {
  _grid.value?.refresh()
}


__expose({
  adaptor: _adaptor, refresh
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(GridComponent), {
    id: "managementList",
    ref_key: "_grid",
    ref: _grid,
    "data-source": _unref(_dataManager),
    "allow-paging": true,
    width: "auto",
    "allow-reordering": true,
    "allow-resizing": true,
    "show-column-menu": false,
    "allow-text-wrap": true,
    "row-selected": onRowSelected,
    "row-deselected": onRowDeselected,
    "page-settings": _pageSettings,
    "selection-settings": selectionOptions
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(ColumnsDirective), null, {
        default: _withCtx(() => [
          _createVNode(_unref(ColumnDirective), {
            type: "checkbox",
            width: "45"
          }),
          _createVNode(_unref(ColumnDirective), {
            field: "cancelationStatusDescription",
            "header-text": "status",
            "auto-fit": true
          }),
          _createVNode(_unref(ColumnDirective), {
            field: "insuranceNumber",
            "header-text": "VR-Nummer",
            "auto-fit": true
          }),
          _createVNode(_unref(ColumnDirective), {
            field: "cancelationRequestDate",
            "header-text": "Angefragt am",
            format: "dd.MM.yyyy HH:mm",
            type: "DateTime",
            "auto-fit": true
          }),
          _createVNode(_unref(ColumnDirective), {
            field: "cancelationRequestByPersonName",
            "header-text": "Angefragt von",
            "auto-fit": true
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data-source"]))
}
}

})